import { OwlModule } from "ngx-owl-carousel";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { SharedModule } from "src/app/shared/shared.module";
import { DatabaseMigrationComponent } from "./database-migration.component";
import { RevolutionSliderDbComponent } from "./revolution-slider-db/revolution-slider-db.component";
import { DatabasesComponent } from "./databases/databases.component";
import { ProductsComponent } from "./products/products.component";
const routes: Routes = [
    { path: '', component: DatabaseMigrationComponent }
  ];
@NgModule({
    declarations: [
       DatabaseMigrationComponent,
       RevolutionSliderDbComponent,
       DatabasesComponent,
       ProductsComponent
    ],
    imports: [
        HttpClientModule,
        CommonModule,
        OwlModule,
        RouterModule,
        SharedModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),
        RouterModule.forChild(routes)

    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ],
    exports: [
        DatabaseMigrationComponent
      ]
  })
  export class DatabaseMigrationModule { }
  export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
  }